package fr.manyverse.app.infrastructure.datastore

actual fun createSoundMetadataDataStore(): SoundMetadataDataStore {
    return JsSoundMetadataDataStore()
}
